const CONST = {
    PAGE_FINANCES: 0,
    PAGE_GOALS: 1,
    PAGE_ACCESS: 2,
    PAGE_FEATURES: 3,
    PAGE_PRODUCTS: 4,

    CONTROL_TOGGLE: 0,
    CONTROL_SELECTOR: 1,

    PRODUCT_DELUXE: 0,
    PRODUCT_SIMPLIFI: 1,
    PRODUCT_HOME_AND_BUSINESS: 2,
    PRODUCT_PREMIER: 3,

    PLATFORM_WEB: 0,
    PLATFORM_WINDOWS: 1,
    PLATFORM_MAC: 2,
    PLATFORM_MOBILE: 3,

    PROMPT_OS: 0,
        OPTION_OS_MAC: 0,
        OPTION_OS_WINDOWS: 1,

    PROMPT_FINANCES: 1,
        OPTION_FINANCES_COMPLEX: 2,
        OPTION_FINANCES_STRAIGHTFORWARD: 3,
        OPTION_FINANCES_BIZ_RENTAL: 4,

    PROMPT_GOALS: 2,
        OPTION_GOALS_BILLS: 5,
        OPTION_GOALS_UNDERSTANDING: 6,
        OPTION_GOALS_BUDGET: 7,
        OPTION_GOALS_SAVE: 8,
        OPTION_GOALS_TAXES: 9,
        OPTION_GOALS_DEBT: 10,
        OPTION_GOALS_RETIREMENT: 11,
        OPTION_GOALS_INVESTMENTS: 12,
        OPTION_GOALS_OTHER: 13,

    PROMPT_ACCESS: 3,
        OPTION_ACCESS_OFFLINE: 14,
        OPTION_ACCESS_WEB: 15,
        OPTION_ACCESS_MOBILE: 16,

    PROMPT_FEATURES: 4,
        OPTION_FEATURES_BILL_PAY: 17,
        OPTION_FEATURES_INVESTMENTS: 18,
        OPTION_FEATURES_TAX_REPORTS: 19
};

export default CONST;